import React, { useEffect, useState, useRef } from 'react';
import Footer from '../../layout/footer/footer';
import './balance.css';
import Beard from '../../assets/images/logo-beard2.svg';
import Img2 from '../../assets/images/img2.png';
import Card from '../../assets/icons/card.svg';
import Refresh from '../../assets/icons/refresh.svg';
import { Form, Modal } from 'react-bootstrap';
import {
    LoadCanvasTemplate,
    loadCaptchaEnginge,
    validateCaptcha
} from 'react-simple-captcha';
import { getInventory } from '../../utils/api';
import { Toast } from 'primereact/toast';
import Loader from '../loader/loader';
import { Dialog } from 'primereact/dialog';
import useStickToTopModal from '../../hooks/useStickToTopModal';
import useToastNotification from '../../hooks/useToastNotification';
import Info from '../../assets/icons/info.svg';

function Balance() {

    const toast = useRef(null);

    const [setting, setSetting] = useState('');

    const [part1, setPart1] = useState('6221');
    const [part2, setPart2] = useState('');
    const [part3, setPart3] = useState('');
    const [part4, setPart4] = useState('');

    const [amount, setAmount] = useState('');
    const [sendPassword, setSendPassword] = useState(false);
    const [validated, setValidated] = useState(false);
    const [balanceVisible, setBalanceVisible] = useState(false);

    const [time, setTime] = useState(240);
    const [resendBtn, setResendBtn] = useState(true);
    const [isActive, setIsActive] = useState(false);

    const [otpVisible, setOtpVisible] = useState(false);
    const [otp, setOtp] = useState('');

    const [mobile, setMobile] = useState('');
    const [paymentUrl, setPaymenturl] = useState('');
    const [nationalId, setNationalId] = useState('');

    const [captchaInput, setCaptchaInput] = useState('');
    const [captchaValid, setCaptchaValid] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [token, setToken] = useState('');
    const [success, setSuccess] = useState('');

    const { showError, showSuccess } = useToastNotification();

    const part2Ref = useRef(null);
    const part3Ref = useRef(null);
    const part4Ref = useRef(null);
    const afterCardNumberRef = useRef(null);


    // ============================================================
    // خواندن شماره کارت از انتهای URL
    //
    // مثال:
    // https://www.kadoona.com/balance/6221062012345678
    //
    // نتیجه:
    // part1 = 6221
    // part2 = 0620
    // part3 = 1234
    // part4 = 5678
    // ============================================================
    useEffect(() => {

        try {

            const pathParts = window.location.pathname
                .split('/')
                .filter(Boolean);

            const cardNumber = pathParts[pathParts.length - 1];

            /*
                شرط:
                - دقیقاً 16 رقم باشد
                - فقط عدد باشد
                - با 62210620 شروع شود
            */
            if (/^62210620\d{8}$/.test(cardNumber)) {

                setPart1(cardNumber.slice(0, 4));
                setPart2(cardNumber.slice(4, 8));
                setPart3(cardNumber.slice(8, 12));
                setPart4(cardNumber.slice(12, 16));
            }

        } catch (error) {
            console.log('Error reading card number from URL:', error);
        }

    }, []);


    // ============================================================
    // تنظیمات اولیه
    // ============================================================
    useEffect(() => {

        setTimeout(() => {

            const set = localStorage.getItem('settings');

            if (set) {
                setSetting(JSON.parse(set));
            }

            loadCaptchaEnginge(
                6,
                'white',
                'black',
                'numbers'
            );

        }, 1000);


        if (localStorage.getItem('userData')) {

            const userData =
                JSON.parse(localStorage.getItem('userData'));

            setToken(userData.token);
        }

    }, []);


    useEffect(() => {

    }, [setting]);


    // ============================================================
    // Captcha
    // ============================================================
    const handleCaptchaValidation = () => {

        if (
            validateCaptcha(
                captchaInput.toLowerCase()
            )
        ) {

            setCaptchaValid(true);

        } else {

            setCaptchaValid(false);

            let message = {
                text: 'لطفا کد امنیتی را صحیح وارد کنید.'
            };

            showError(message);

            return;
        }
    };


    // ============================================================
    // Card Number Inputs
    // ============================================================
    const handlePart1Change = (e) => {

        const value = e.target.value;

        setPart1(value);

        if (
            value.length === 4 &&
            part2Ref.current
        ) {
            part2Ref.current.focus();
        }
    };


    const handlePart2Change = (e) => {

        const value = e.target.value;

        if (value.length <= 4) {

            setPart2(value);

            if (
                value.length === 4 &&
                part3Ref.current
            ) {
                part3Ref.current.focus();
            }
        }
    };


    const handlePart3Change = (e) => {

        const value = e.target.value;

        if (value.length <= 4) {

            setPart3(value);

            if (
                value.length === 4 &&
                part4Ref.current
            ) {
                part4Ref.current.focus();
            }
        }
    };


    const handlePart4Change = (e) => {

        const value = e.target.value;

        if (value.length <= 4) {

            setPart4(value);

            if (
                value.length === 4 &&
                afterCardNumberRef.current
            ) {
                afterCardNumberRef.current.focus();
            }
        }
    };


    // ============================================================
    // Paste Card Number
    // ============================================================
    const updateCardNumberViaPaste = (card) => {

        if (!/^62210620\d{8}$/.test(card)) {
            return;
        }

        setPart1(card.slice(0, 4));
        setPart2(card.slice(4, 8));
        setPart3(card.slice(8, 12));
        setPart4(card.slice(12, 16));
    };


    const onCardPaste = (e) => {

        e.preventDefault();

        let value =
            e.clipboardData
                .getData('text')
                .replace(/\D/g, '');

        if (
            !value ||
            value.length !== 16
        ) {
            return;
        }

        updateCardNumberViaPaste(value);
    };


    // ============================================================
    // Timer
    // ============================================================
    useEffect(() => {

        let timerId;

        if (
            isActive &&
            time > 0
        ) {

            timerId = setInterval(() => {

                setTime(
                    prevTime =>
                        prevTime - 1
                );

            }, 1000);

        } else if (time === 0) {

            onTimerFinish();
        }

        return () =>
            clearInterval(timerId);

    }, [isActive, time]);


    const onTimerFinish = () => {
        setResendBtn(false);
    };


    const formatTime = (time) => {

        const minutes =
            String(
                Math.floor(time / 60)
            ).padStart(2, '0');

        const seconds =
            String(
                time % 60
            ).padStart(2, '0');

        return `${minutes}:${seconds}`;
    };


    // ============================================================
    // Submit
    // ============================================================
    const showCardBalance = async (e) => {

        e.preventDefault();

        const form = e.currentTarget;

        if (
            form.checkValidity() === true
        ) {

            if (
                !validateCaptcha(
                    captchaInput.toLowerCase()
                )
            ) {

                setCaptchaValid(false);

                let message = {
                    text: 'لطفا کد امنیتی را صحیح وارد کنید.'
                };

                showError(message);

                loadCaptchaEnginge(
                    6,
                    'white',
                    'black',
                    'numbers'
                );

                setCaptchaInput('');

            } else {

                gotoBalance();
            }
        }

        setValidated(true);
    };


    // ============================================================
    // Get Inventory
    // ============================================================
    const gotoBalance = async (e) => {

        if (e) {
            e.preventDefault();
        }

        try {

            setLoading(true);

            let params = {

                cardNumber:
                    `${part1}${part2}${part3}${part4}`,

                mobile: mobile,

                nationalCode: nationalId,

                sendPassword: sendPassword,

                otp:
                    otp === ''
                        ? undefined
                        : otp
            };


            let res =
                await getInventory(params);


            if (res.data.isSuccess) {

                setLoading(false);


                if (
                    res.data.data.sendOtp
                ) {

                    setOtpVisible(true);

                    setTime(240);

                    setIsActive(true);

                    setResendBtn(true);

                } else {

                    setOtpVisible(false);


                    if (
                        res.data.data.urlRedirect
                    ) {

                        setPaymenturl(
                            res.data.data.urlRedirect
                        );

                        setAmount(
                            res.data.data.amount
                        );

                        setShowPaymentModal(true);

                    } else {

                        showSuccess(
                            'موجودی کارت برای شما پیامک شد'
                        );

                        loadCaptchaEnginge(
                            6,
                            'white',
                            'black',
                            'numbers'
                        );
                    }

                    setLoading(false);
                }

            } else {

                let message = {
                    text:
                        res.data.message
                };

                showError(message);

                loadCaptchaEnginge(
                    6,
                    'white',
                    'black',
                    'numbers'
                );

                setCaptchaInput('');

                setLoading(false);

                setShowPaymentModal(false);
            }


        } catch (error) {

            setLoading(false);

            let message = {
                text: 'خطا در ارتباط با سرور'
            };

            showError(message);
        }
    };


    const {
        modalClassName,
        onKeyboardClose,
        onKeyboardOpen,
        stickToTop
    } = useStickToTopModal();


    function convertToPersianNumbers(input) {

        const persianDigits = [
            '۰',
            '۱',
            '۲',
            '۳',
            '۴',
            '۵',
            '۶',
            '۷',
            '۸',
            '۹'
        ];

        return input.replace(
            /\d/g,
            (digit) =>
                persianDigits[digit]
        );
    }


    const [
        showPaymentModal,
        setShowPaymentModal
    ] = React.useState(false);


    return (
        <div>

            <Toast ref={toast} />

            <div className="container">

                <div className="d-flex align-items-center title gap-3">

                    <img
                        src={Beard}
                        alt="Logo"
                    />

                    استعلام کادونا

                </div>


                <h6
                    className="text-[#0033CC] text-sm px-5 d-block d-sm-none"
                >
                    برای اطلاع از وضعیت کادونا و یا اطلاع از موجودی آن
                    و حتی پیگیری مراحل شارژ کادونا از این طریق اقدام کنید
                </h6>


                {token && token !== '' ? (

                    // ========================================================
                    // USER LOGGED IN
                    // ========================================================
                    <div className="d-flex align-items-center justify-content-between gap-5 mt-3 w-100 flex-col-revers mb-5">


                        <div className="charging-card mb-5">


                            {error && (
                                <div className="alert alert-danger">
                                    {error}
                                </div>
                            )}


                            {success && (
                                <div className="alert alert-success">
                                    {success}
                                </div>
                            )}


                            <h6 className="text-[#0033CC] text-sm text-center py-2 px-5 d-none d-md-block">

                                <img
                                    src={Info}
                                    alt=""
                                    className="position-absolute"
                                />

                                <span className="px-1 mx-3">
                                    برای اطلاع از وضعیت کادونا و یا اطلاع از موجودی آن و
                                </span>

                                حتی مراحل شارژ کادونا از این طریق اقدام کنید

                            </h6>


                            <hr />


                            <Form
                                noValidate
                                validated={validated}
                                onSubmit={showCardBalance}
                            >


                                {/* شماره کارت */}
                                <Form.Group controlId="text">


                                    <Form.Label>

                                        شماره کارت کادونا

                                        <span className="text-[red]">
                                            {' '}*{' '}
                                        </span>

                                    </Form.Label>


                                    <div
                                        className="input-icon"
                                        style={{
                                            direction: 'ltr'
                                        }}
                                    >


                                        <img
                                            src={Card}
                                            alt="Card Icon"
                                        />


                                        {/* PART 1 */}
                                        <Form.Control
                                            type="number"
                                            readOnly
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part1}
                                            onChange={handlePart1Change}
                                        />

                                        {' '}-{' '}


                                        {/* PART 2 */}
                                        <Form.Control
                                            type="number"
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part2}
                                            onChange={handlePart2Change}
                                            onPaste={onCardPaste}
                                            id="web-card-2"
                                            ref={part2Ref}
                                        />

                                        {' '}-{' '}


                                        {/* PART 3 */}
                                        <Form.Control
                                            type="number"
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part3}
                                            onChange={handlePart3Change}
                                            onPaste={onCardPaste}
                                            ref={part3Ref}
                                            id="web-card-3"
                                        />

                                        {' '}-{' '}


                                        {/* PART 4 */}
                                        <Form.Control
                                            type="number"
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part4}
                                            onChange={handlePart4Change}
                                            onPaste={onCardPaste}
                                            ref={part4Ref}
                                            id="web-card-4"
                                        />

                                    </div>

                                </Form.Group>


                                {/* ارسال رمز عبور */}
                                <Form.Group className="mt-3 send-password">
                                    <Form.Check
                                        type="checkbox"
                                        id="send-password-authenticated"
                                        label="ارسال رمز عبور"
                                        checked={sendPassword}
                                        onChange={(e) => setSendPassword(e.target.checked)}
                                    />
                                </Form.Group>


                                {/* Captcha */}
                                <Form.Group className="mt-3">

                                    <Form.Label>

                                        کد امنیتی

                                        <span className="text-[red]">
                                            {' '}*{' '}
                                        </span>

                                    </Form.Label>


                                    <div className="d-flex align-items-center">


                                        <Form.Control
                                            value={captchaInput}
                                            onChange={(e) =>
                                                setCaptchaInput(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="کد امنیتی را وارد کنید"
                                            ref={afterCardNumberRef}
                                        />


                                        <div className="captcha-container d-flex align-items-center h-[48px] gap-2 ms-2">


                                            <LoadCanvasTemplate />


                                            <button
                                                type="button"
                                                onClick={() => {

                                                    loadCaptchaEnginge(
                                                        6,
                                                        'white',
                                                        'black',
                                                        'numbers'
                                                    );

                                                    setCaptchaInput('');

                                                }}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    fontSize: '18px',
                                                    color: '#007BFF',
                                                    marginLeft: '10px',
                                                    width: '18px'
                                                }}
                                                title="تولید مجدد کد امنیتی"
                                            >

                                                <img
                                                    src={Refresh}
                                                    alt=""
                                                />

                                            </button>

                                        </div>

                                    </div>

                                </Form.Group>


                                <button
                                    className="btn btn-primary w-100 mt-3 text-center"
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        width: 'auto'
                                    }}
                                >

                                    استعلام کادونا

                                    {loading
                                        ? <Loader />
                                        : ''
                                    }

                                </button>

                            </Form>

                        </div>


                        <div
                            className="flex-1"
                            style={{
                                textAlign: '-webkit-left'
                            }}
                        >

                            <img
                                src={Img2}
                                alt="Illustration"
                            />

                        </div>

                    </div>

                ) : (

                    // ========================================================
                    // USER NOT LOGGED IN
                    // ========================================================
                    <div className="d-flex align-items-center justify-content-between gap-5 mt-3 w-100 flex-col-revers mb-5">


                        <div className="charging-card mb-5">


                            {error && (
                                <div className="alert alert-danger">
                                    {error}
                                </div>
                            )}


                            {success && (
                                <div className="alert alert-success">
                                    {success}
                                </div>
                            )}


                            <Form
                                noValidate
                                validated={validated}
                                onSubmit={showCardBalance}
                            >


                                {/* شماره کارت */}
                                <Form.Group controlId="text">


                                    <Form.Label>

                                        شماره کارت کادونا

                                        <span className="text-[red]">
                                            {' '}*{' '}
                                        </span>

                                    </Form.Label>


                                    <div
                                        className="input-icon"
                                        style={{
                                            direction: 'ltr'
                                        }}
                                    >


                                        <img
                                            src={Card}
                                            alt="Card Icon"
                                        />


                                        <Form.Control
                                            type="number"
                                            readOnly
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part1}
                                            onChange={handlePart1Change}
                                        />

                                        {' '}-{' '}


                                        <Form.Control
                                            type="number"
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part2}
                                            onChange={handlePart2Change}
                                            onPaste={onCardPaste}
                                            ref={part2Ref}
                                            id="web-card-2"
                                        />

                                        {' '}-{' '}


                                        <Form.Control
                                            type="number"
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part3}
                                            onChange={handlePart3Change}
                                            onPaste={onCardPaste}
                                            ref={part3Ref}
                                            id="web-card-3"
                                        />

                                        {' '}-{' '}


                                        <Form.Control
                                            type="number"
                                            inputMode="numeric"
                                            className="text-center number"
                                            value={part4}
                                            onChange={handlePart4Change}
                                            onPaste={onCardPaste}
                                            ref={part4Ref}
                                            id="web-card-4"
                                        />

                                    </div>

                                </Form.Group>


                                {/* ارسال رمز عبور */}
                                <Form.Group className="mt-3">
                                    <Form.Check
                                        type="checkbox"
                                        id="send-password-guest"
                                        label="ارسال رمز عبور"
                                        checked={sendPassword}
                                        onChange={(e) => setSendPassword(e.target.checked)}
                                    />
                                </Form.Group>


                                {/* Mobile */}
                                <Form.Group className="mt-3">

                                    <Form.Label>

                                        شماره موبایل

                                        <span className="text-[red]">
                                            {' '}*{' '}
                                        </span>

                                    </Form.Label>


                                    <Form.Control
                                        required
                                        type="number"
                                        inputMode="numeric"
                                        value={mobile}
                                        ref={afterCardNumberRef}
                                        onChange={(e) => {

                                            if (
                                                e.target.value.length <= 11
                                            ) {

                                                setMobile(
                                                    e.target.value
                                                );
                                            }
                                        }}
                                    />


                                    <Form.Control.Feedback type="invalid">
                                        لطفا شماره را وارد کنید
                                    </Form.Control.Feedback>

                                </Form.Group>


                                {/* National ID */}
                                <Form.Group className="mt-3">

                                    <Form.Label>

                                        کدملی

                                        <span className="text-[red]">
                                            {' '}*{' '}
                                        </span>

                                    </Form.Label>


                                    <Form.Control
                                        required
                                        type="number"
                                        inputMode="numeric"
                                        value={nationalId}
                                        onChange={(e) =>
                                            setNationalId(
                                                e.target.value
                                            )
                                        }
                                    />


                                    <Form.Control.Feedback type="invalid">
                                        لطفا کدملی را وارد کنید
                                    </Form.Control.Feedback>

                                </Form.Group>


                                {/* Captcha */}
                                <Form.Group className="mt-3">

                                    <Form.Label>

                                        کد امنیتی

                                        <span className="text-[red]">
                                            {' '}*{' '}
                                        </span>

                                    </Form.Label>


                                    <div className="d-flex align-items-center">


                                        <Form.Control
                                            value={captchaInput}
                                            onChange={(e) =>
                                                setCaptchaInput(
                                                    e.target.value
                                                )
                                            }
                                            placeholder="کد امنیتی را وارد کنید"
                                        />


                                        <div className="captcha-container d-flex align-items-center h-[48px] gap-2 ms-2">


                                            <LoadCanvasTemplate />


                                            <button
                                                type="button"
                                                onClick={() => {

                                                    loadCaptchaEnginge(
                                                        6,
                                                        'white',
                                                        'black',
                                                        'numbers'
                                                    );

                                                    setCaptchaInput('');

                                                }}
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    cursor: 'pointer',
                                                    fontSize: '18px',
                                                    color: '#007BFF',
                                                    marginLeft: '10px',
                                                    width: '18px'
                                                }}
                                                title="تولید مجدد کد امنیتی"
                                            >

                                                <img
                                                    src={Refresh}
                                                    alt=""
                                                />

                                            </button>

                                        </div>

                                    </div>

                                </Form.Group>


                                <button
                                    className="btn btn-primary w-100 mt-3 text-center"
                                    type="submit"
                                    disabled={loading}
                                    style={{
                                        width: 'auto'
                                    }}
                                >

                                    مشاهده موجودی

                                    {loading
                                        ? <Loader />
                                        : ''
                                    }

                                </button>


                                <div className="d-flex gap-2 mt-3 align-items-start">


                                    <img
                                        src={Info}
                                        alt=""
                                    />


                                    <div>

                                        <h6 className="text-[#0033CC] text-sm">

                                            {
                                                convertToPersianNumbers(
                                                    'کارت شارژ شده، پس از 48 ساعت فعال و قابل استفاده خواهد بود.'
                                                )
                                            }

                                        </h6>

                                    </div>

                                </div>

                            </Form>

                        </div>


                        <div
                            className="flex-1"
                            style={{
                                textAlign: '-webkit-left'
                            }}
                        >

                            <img
                                src={Img2}
                                alt="Illustration"
                            />

                        </div>

                    </div>

                )}

            </div>


            {/* ============================================================
                Balance Dialog
            ============================================================ */}
            <Dialog
                className={`animation ${
                    stickToTop
                        ? modalClassName
                        : ''
                }`}
                header="موجودی"
                visible={balanceVisible}
                style={{
                    width: '40vw'
                }}
                onHide={() => {

                    if (!balanceVisible)
                        return;

                    setBalanceVisible(false);

                    setLoading(false);

                    loadCaptchaEnginge(
                        6,
                        'white',
                        'black',
                        'numbers'
                    );
                }}
            >

                <div className="login-card w-100">

                    <div className="item mx-0">

                        <h6 className="text-xl font-medium color-primary2 mt-5">

                            موجودی کارت برای شما پیامک شد.

                        </h6>

                    </div>

                </div>

            </Dialog>


            {/* ============================================================
                OTP Dialog
            ============================================================ */}
            <Dialog
                className={`animation ${
                    stickToTop
                        ? modalClassName
                        : ''
                }`}
                header="کد تایید"
                visible={otpVisible}
                style={{
                    width: '40vw'
                }}
                onHide={() => {

                    if (!otpVisible)
                        return;

                    setOtpVisible(false);

                    setLoading(false);

                    loadCaptchaEnginge(
                        6,
                        'white',
                        'black',
                        'numbers'
                    );
                }}
            >

                <div className="login-card w-100">

                    <div className="item mx-0">


                        <h6 className="text-xl font-medium color-primary2 mt-5">

                            کد تایید ارسالی برای شماره {mobile} را وارد کنید.

                        </h6>


                        <Form
                            className="mt-5"
                            noValidate
                            validated={validated}
                            onSubmit={gotoBalance}
                        >


                            <Form.Group controlId="postalCode">


                                <Form.Label
                                    style={{
                                        fontWeight: '600'
                                    }}
                                >
                                    کد تایید
                                </Form.Label>


                                <Form.Control
                                    className="number"
                                    type="number"
                                    autoComplete="one-time-code"
                                    inputMode="numeric"
                                    required
                                    value={otp}
                                    onChange={(e) => {

                                        if (
                                            e.target.value.length <= 6
                                        ) {

                                            setOtp(
                                                e.target.value
                                            );
                                        }
                                    }}
                                    onKeyDown={(e) => {

                                        if (
                                            e.key === 'Enter'
                                        ) {

                                            e.preventDefault();

                                            gotoBalance(e);
                                        }
                                    }}
                                    onBlur={
                                        onKeyboardClose
                                    }
                                    onFocus={
                                        onKeyboardOpen
                                    }
                                />

                            </Form.Group>


                            <button
                                type="button"
                                disabled={resendBtn}
                                className="btn w-100 text-center mt-2 number"
                                onClick={gotoBalance}
                            >

                                {
                                    resendBtn
                                        ? formatTime(time)
                                        : 'ارسال مجدد'
                                }

                            </button>


                            <button
                                className="btn btn-primary w-100 mt-2 text-center"
                                disabled={loading}
                                type="submit"
                                style={{
                                    width: 'auto'
                                }}
                            >

                                ادامه

                                {loading && <Loader />}

                            </button>

                        </Form>

                    </div>

                </div>

            </Dialog>


            {/* ============================================================
                Payment Modal
            ============================================================ */}
            <Modal
                show={showPaymentModal}
                onHide={() =>
                    setShowPaymentModal(false)
                }
                centered
            >

                <Modal.Body className="!p-5">


                    <div className="flex gap-1 border-b-[#668CFF] border-b-[1px] pb-3">

                        <img
                            src={
                                require(
                                    '../../assets/icons/danger.svg'
                                ).default
                            }
                            alt=""
                        />

                        <div className="font-bold text-blue">
                            هشدار
                        </div>

                    </div>


                    <div className="font-bold mt-4">

                        برای مشاهده ی موجودی باید مبلغ{' '}

                        {
                            parseInt(
                                amount || 0
                            ).toLocaleString()
                        }

                        {' '}تومان بپردازید.

                    </div>


                    <div className="font-bold mt-4">

                        آیا از پرداخت این مبلغ اطمینان دارید؟

                    </div>


                    <div className="flex gap-2 mt-4">


                        <button
                            className="btn btn-outline-primary !border-1 !border-blue flex-1"
                            onClick={() =>
                                setShowPaymentModal(false)
                            }
                        >
                            انصراف
                        </button>


                        <button
                            className="btn btn-primary flex-[2]"
                            disabled={loading}
                            onClick={() =>
                                window.location.replace(
                                    paymentUrl
                                )
                            }
                        >

                            تایید

                            {loading
                                ? <Loader />
                                : ''
                            }

                        </button>

                    </div>

                </Modal.Body>

            </Modal>


            <div className="home-footer mt-40">

                <Footer />

            </div>

        </div>
    );
}

export default Balance;